import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';
import Home from '../views/Home.vue';
import QuoteLookup from '@/views/quote/QuoteLookup';
import QuoteEstimate from '@/views/quote/QuoteEstimate';
import VehicleLookup from '@/views/vehicle/VehicleLookup';
import VehicleStatus from '@/views/vehicle/VehicleStatus';
import PageNotFound from '@/views/PageNotFound';
import GuestSignin from '@/views/guestLogin/GuestLogin';
import Profile from '@/views/profile/Profile';
import RenewReg from '@/views/renewReg/RenewReg';
import DuplicateReg from '@/views/duplicateReg/DuplicateReg';
import CancelReg from '@/views/cancelReg/CancelReg';
import MultiFactAuth from '@/views/multiFactorAuth/MultiFactAuth';
import ContactInfo from '@/views/contactInfo/ContactInfo';
import AddressInfo from '@/views/addressInfo/AddressInfo';
import CommunicationInfo from '@/views/communicationInfo/CommunicationInfo.vue';
import { transitionNetworkStatus, validateBrowser } from '@/utils/networkUtils';
import BusinessContactInfo from '@/views/business/contactInfo/ContactInfo';
import BusinessAddressInfo from '@/views/business/addressInfo/AddressInfo';
import BusinessProfile from '@/views/business/profile/BusinessProfile';
import DuplicateTitle from '@/views/duplicateTitle/DuplicateTitle';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/fee-lookup',
    name: 'QuoteLookup',
    component: QuoteLookup
  },
  {
    path: '/fee-estimate',
    name: 'QuoteEstimate',
    component: QuoteEstimate
  },
  {
    path: '/vehicle-lookup',
    name: 'VehicleLookup',
    component: VehicleLookup
  },
  {
    path: '/vehicle-status',
    name: 'VehicleStatus',
    component: VehicleStatus
  },
  {
    path: '/404',
    name: 'PageNotFound',
    component: PageNotFound
  },
  {
    path: '/guest-signin',
    name: 'GuestSignin',
    component: GuestSignin,
    meta: {disallowAuthed : true},
  },
  {
    path: '/mfa',
    name: 'MultiFactAuth',
    component: MultiFactAuth,
    meta: {disallowAuthed : true},
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    // meta: {auth : true},
    
    beforeEnter: (to, from, next) => {
      if (store.getters['guestLogin/statusInfo'].accessToken === '') {
        sessionStorage.clear();
        localStorage.clear();
        next ({name : 'GuestSignin'})
      }
      else {
        // Browser back from payment/confirmation leaves step > 4, which hides the cart icon
        if(store.state.guestLogin.step > 4) {
          store.state.guestLogin.step = 1;
        }
        document.body.setAttribute("tabindex", "1");
        document.body.focus();

        document.body.removeAttribute("tabindex");
        document.getElementById("app").scrollTop = 0;
        next ();
      }
    }
  },
  {
    path: '/update-contacts',
    name: 'UpdateContacts',
    component: ContactInfo,
    // meta: {disallowAuthed : true},

    beforeEnter: (to, from, next) => {
      document.body.setAttribute("tabindex", "1");
      document.body.focus();

      document.body.removeAttribute("tabindex");
      document.getElementById("app").scrollTop = 0;
      next ();
    }
  },
  {
    path: '/update-address',
    name: 'UpdateAddress',
    component: AddressInfo,
    // meta: {disallowAuthed : true},

    beforeEnter: (to, from, next) => {
      document.body.setAttribute("tabindex", "1");
      document.body.focus();

      document.body.removeAttribute("tabindex");
      document.getElementById("app").scrollTop = 0;
      next ();
    }
  },
  {
    path: '/update-communication',
    name: 'UpdateCommunication',
    component: CommunicationInfo,
    // meta: {disallowAuthed : true},

    beforeEnter: (to, from, next) => {
      document.body.setAttribute("tabindex", "1");
      document.body.focus();

      document.body.removeAttribute("tabindex");
      document.getElementById("app").scrollTop = 0;
      next ();
    }
  },
  {
    path: '/duplicate-title',
    name: 'DuplicateTitle',
    component: DuplicateTitle,
    // meta: {disallowAuthed : true},

    beforeEnter: (to, from, next) => {
      document.body.setAttribute("tabindex", "1");
      document.body.focus();

      document.body.removeAttribute("tabindex");
      document.getElementById("app").scrollTop = 0;
      next ();
    }
  },
  {
    path: '/renew-reg',
    name: 'RenewReg',
    component: RenewReg,
    // meta: {disallowAuthed : true},

    beforeEnter: (to, from, next) => {
      document.body.setAttribute("tabindex", "1");
      document.body.focus();

      document.body.removeAttribute("tabindex");
      document.getElementById("app").scrollTop = 0;
      next ();
    }
  },
  {
    path: '/duplicate-reg',
    name: 'DuplicateReg',
    component: DuplicateReg,
    // meta: {disallowAuthed : true},

    beforeEnter: (to, from, next) => {
      document.body.setAttribute("tabindex", "1");
      document.body.focus();

      document.body.removeAttribute("tabindex");
      document.getElementById("app").scrollTop = 0;
      next ();
    }
  },
  {
    path: '/cancel-reg',
    name: 'CancelReg',
    component: CancelReg,
    // meta: {disallowAuthed : true},

    beforeEnter: (to, from, next) => {
      document.body.setAttribute("tabindex", "1");
      document.body.focus();

      document.body.removeAttribute("tabindex");
      document.getElementById("app").scrollTop = 0;
      next ();
    }
  },
  {
    path: '/businessprofile',
    name: 'BusinessProfile',
    component: BusinessProfile,
    // meta: {auth : true},
    
    beforeEnter: (to, from, next) => {
      if (store.getters['guestLogin/statusInfo'].accessToken === '') {
        sessionStorage.clear();
        localStorage.clear();
        next ({name : 'GuestSignin'})
      }
      else {
        // Browser back from payment/confirmation leaves step > 4, which hides the cart icon
        if(store.state.guestLogin.step > 4) {
          store.state.guestLogin.step = 1;
        }
        document.body.setAttribute("tabindex", "1");
        document.body.focus();

        document.body.removeAttribute("tabindex");
        document.getElementById("app").scrollTop = 0;
        next ();
      }
    }
  },
  {
    path: '/business/update-contacts',
    name: 'BusinessUpdateContacts',
    component: BusinessContactInfo,
    // meta: {disallowAuthed : true},
    beforeEnter: (to, from, next) => {
      document.body.setAttribute("tabindex", "1");
      document.body.focus();
      document.body.removeAttribute("tabindex");
      document.getElementById("app").scrollTop = 0;
      next();
    }
  },
  {
    path: '/business/update-address',
    name: 'BusinessUpdateAddress',
    component: BusinessAddressInfo,
    
    beforeEnter: (to, from, next) => {
      document.body.setAttribute("tabindex", "1");
      document.body.focus();
      document.body.removeAttribute("tabindex");
      document.getElementById("app").scrollTop = 0;
      next();
    }
  }
];

const router = createRouter({
  history: createWebHistory(),
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { 
        el: to.hash
      }; // scroll to anchor
    }

    if (savedPosition) {
      return savedPosition;
    }

    return { top: 0 };
  },
  routes
});

router.beforeEach(async (to, from) => {  
  // 404: No matched route found
  if (!to.matched.length) {                 
    console.warn('[Route Guard] Not found:', to);
    // Return the route to redirect to the 404 page
    return { name: 'PageNotFound' };
  }
  
  // Enforce returning to VehicleLookup for VehicleStatus
  if (to.name === 'VehicleStatus' && from.name !== 'VehicleLookup') {
    // Return the route to redirect
    return { name: 'VehicleLookup' };
  }
  
  // Standard handling (not directly related to routing changes)
  validateBrowser();
  transitionNetworkStatus();
});

export default router;
